export default {
  on: {
    pageInit() {
      // 관리자일 경우 선택한 관광지 정보 설정
      if (this.$root.$data.group_code == 'A') {
        console.log('tourist_id: ' + localStorage.tourist_id);
        console.log('tourist_id: ' + this.$root.$data.tourist_id + ', tourist_name: ' + this.$root.$data.admin_tourist_name);

        this.$root.$data.tourist_id = localStorage.tourist_id;
        this.$root.$data.admin_tourist_name = localStorage.admin_tourist_name;

        this.admin_tourist_id = this.$root.$data.tourist_id;
        this.$$('#admin_tourist_id').parent().find('.item-after').html(this.$root.$data.admin_tourist_name);
      }
    }
  },
  data() {
    // 관리자일 경우 관광지 목록 가져오기
    if (this.$root.$data.group_code == 'A') {
      this.getTouristList();
    }

    return {
      use_barcode_limit: this.$root.$data.use_barcode_limit,
      auto_login: this.$root.$data.auto_login,
      admin_tourist_id: '',
      list_tourist: []
    }
  },
  methods: {
    /**
     * 바코드 제한시간 적용 변경
     */
    changeTimeLimit(event) {
      localStorage.use_barcode_limit_yn = (event.target.checked ? 'Y' : 'N');
      this.$root.$data.use_barcode_limit = event.target.checked;

      var formdata = new FormData();
      formdata.set('admin_id', localStorage.admin_id);
      formdata.set('use_barcode_limit_yn', localStorage.use_barcode_limit_yn);

      var _this = this;
      this.$http.post(_this.$api_base_uri + '/update_pos_config', formdata, {
        timeout: 10000
      })
      .then(function(response) { /* console.log(response); */ })
      .catch(function(error) {
        //console.log(error);
        _this.$f7.dialog.alert('환경설정 정보 저장 중 오류가 발생했습니다.<br>' + error, '환경설정');
      });
    },

    /**
     * 자동로그인
     */
    changeAutoLogin(event) {
      localStorage.auto_login = event.target.checked;
      this.$root.$data.auto_login = event.target.checked;
    },

    /**
     * 관광지 목록 가져오기
     */
    getTouristList() {
      var _this = this;
      _this.$http.get(_this.$api_base_uri + '/get_tourist_list', {
        timeout: 30000
      })
      .then(function(response) {
        if (response.data.result) {
          // 배열 초기화
          if (_this.list_tourist.length > 0) {
            _this.list_tourist.splice(0, _this.list_tourist.length);
          }

          // 관광지 목록 처리
          var cnt_list = response.data.list.length;
          for (var i = 0; i < cnt_list; i++) {
            var tourist_name = response.data.list[i].tourist + ' - ' + response.data.list[i].login_id;
            _this.list_tourist.push({
              admin_id: response.data.list[i].admin_id,
              tourist_id: response.data.list[i].tourist_id,
              tourist_name: tourist_name
            });
          } // end of for
        } else {
          _this.$f7.dialog.alert('관광지 목록을 가져오던 중 오류가 발생했습니다.(' + response.data.msg + ')', '환경설정');
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    },

    /**
     * 관광지 변경
     */
    onChangeTourist() {
      var tourist_id = event.target.value;
      var tourist_name = '';

      if (tourist_id != '') {
        this.$$('#admin_tourist_id').children().each(function(index, el) {
          if (el.selected) {
            tourist_name = el.text;
            console.log('selected index: ' + index + ', text: ' + el.text + ', value: ' + el.value);
          }
        });
      }

      localStorage.tourist_id = tourist_id;
      localStorage.admin_tourist_name = tourist_name;

      this.$root.$data.tourist_id = tourist_id;
      this.$root.$data.admin_tourist_name = tourist_name;
    }

  }
}


// WEBPACK FOOTER //
// ./src/js/settings.js